import type { ItemSalesGroup } from '../types'

/** Which figures the item table prints — the item report, read three ways. */
export const ItemSalesReading = {
  /** What sold and what it brought in. */
  Sales: 'sales',
  /** Net against cost — the legacy Gross Profit by Item. */
  Profit: 'profit',
  /** What each unit sold earned the cashier. */
  Incentive: 'incentive',
} as const

export type ItemSalesReading = (typeof ItemSalesReading)[keyof typeof ItemSalesReading]

/** A block's name, from a server either side of `groupBy`. */
export function itemGroupName(group: ItemSalesGroup): string {
  return group.name ?? group.categoryName
}
